/* @flow */
// first because it patches runtime env
import 'polyfill';
import 'utils/setupErrorLogging';

import invariant from 'invariant';
import * as React from 'react';
import ReactDOM from 'react-dom';
import { AppContainer } from 'react-hot-loader';

import { getApolloClientSingleton } from 'lib/apollo/client/browser';
import Root from 'messages/Root';

import Config from 'Config';

import '../styles/app.scss';

__webpack_public_path__ = Config.Environment.PUBLIC_PATH; // eslint-disable-line

const container = document.getElementById('app');
invariant(container, 'messages app missing container');

ReactDOM.render(
  <AppContainer>
    <Root apolloClient={getApolloClientSingleton()} />
  </AppContainer>,
  container
);

// $FlowFixMe Flow doesn't know about `module.hot`
if (module.hot) {
  // $FlowFixMe Flow doesn't know about `module.hot`
  module.hot.accept('messages/Root', () => {
    const NextRoot = require('messages/Root').default;
    ReactDOM.render(
      <AppContainer>
        <NextRoot apolloClient={getApolloClientSingleton()} />
      </AppContainer>,
      container
    );
  });
}
